import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const SketchNoteLogoSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00101051 16.2882C0.435557 7.53286 7.47955 0.501563 16.2871 0.00136726C16.8154 -0.0286393 17.2217 0.439803 17.1432 0.95897L15.3446 12.8534H20.7547C21.2327 12.8534 21.6225 13.2383 21.599 13.7119C21.1645 22.4672 14.1205 29.4985 5.31297 29.9987C4.78462 30.0287 4.37835 29.5603 4.45685 29.0411L6.25542 17.1467H0.845379C0.367307 17.1467 -0.0224988 16.7618 0.00101051 16.2882Z"
        fill={fill}
      />
    </svg>
  </span>
);

export default SketchNoteLogoSVG;
